import { Theme } from '@mui/material';
import styled from 'styled-components';

interface StyledCardProps {
  $selected: boolean;
  $break: boolean;
  $isThisWeek: boolean;
}

const getCardBorder = (
  theme: Theme, $selected: boolean, $break: boolean, $isThisWeek:boolean) => {
  if ($selected) return `1.5px solid ${theme.palette.info.main}`;
  if ($break) return `1.5px solid ${theme.palette.lightBlue.dark}`;
  if ($isThisWeek) return `1.5px solid ${theme.palette.lightRed.main}`;
  return `1.5px solid ${theme.palette.backdrop.dark}`;
};

const getCardBackground = (
  theme: Theme, $selected: boolean, $break: boolean, $isThisWeek:boolean) => {
  if ($selected) return theme.palette.info.light;
  if ($break) return theme.palette.lightBlue.main;
  if ($isThisWeek) return theme.palette.lightRed.light;
  return theme.palette.backdrop.main;
};

export const StyledCard = styled.div<StyledCardProps>`
  background-color: ${({ theme, $selected, $break, $isThisWeek }) => getCardBackground(theme, $selected, $break, $isThisWeek)};
  border-radius: ${({ theme }) => theme.shape.borderRadius * 2}px;
  outline: ${({ theme, $selected }) => ($selected ? `1.5px solid ${theme.palette.info.main}` : 'none')};
  border: ${({ theme, $break, $selected, $isThisWeek }) => getCardBorder(theme, $selected, $break, $isThisWeek)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(1)};
  width: 96px;
`;
